/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { prepareMSTLayoutModelType, composeMSTLayoutModel } from './MSTLayoutModel';
import { CardLayoutModelExt } from './CardLayoutModelExt';
import { ExploreContainerLayoutModelExt } from './ExploreContainerLayoutModelExt';
import { WidgetLayoutModelExt } from './WidgetLayoutModelExt';


const layoutTypes = {
	'exploreContainer': ExploreContainerLayoutModelExt,
	'exploreCard': CardLayoutModelExt,
	'widget': WidgetLayoutModelExt
};

function getItemsModelTypeFn( snapshot, env, getItemsModelTypeFn ) {
	let modelType;

	if( snapshot && layoutTypes[snapshot.type] ) {
		const extModel = layoutTypes[snapshot.type];
		modelType = composeMSTLayoutModel(env, extModel, getItemsModelTypeFn)
			.named(snapshot.type);
	} else {
		modelType = composeMSTLayoutModel(env);
	}
	return modelType;
}


/**
 * This creates a MST LayoutModel instance
 *
 * @param {object} model the JSON spec for the model
 * @param {object} env the environment parameters used for creating the Model
 * @param {object} [env.whitelistAttrs] white list attributes allowed for the Model, optional
 * @param {object} [env.options] any options needed for preparing the Model, optional
 * @param {object} env.boardModel legacy BoardModel
 * @param {object} env.logger logger instance to be used
 */
export function createMSTLayoutModel( model, env){
	const idMap = {};
	const logger = env && env.logger;

	//Don't particularly like doing this here, mobx seems to allow models with duplicate ids in the passed snapshot
	//also, preProcessSnapshot does not work for this type of functionality as it calls preProcessSnapshot
	//for nested models again (from the original snapshot)
	function trimDuplicateModels( item ) {
		let copy= {};
		Object.keys(item).forEach(function(key) {
			if( key !== 'items') {
				if( copy ) {
					copy[key] = item[key];
				}
				if(key === 'id' ) {
					if( idMap[item.id] ) {
						copy = null;
					} else {
						idMap[item.id] = true;
					}
				}
			} else {
				copy.items = [];
				for( let i=0; item.items && i < item.items.length; i++) {
					const child = trimDuplicateModels( item.items[i] );
					if(child) {
						copy.items.push(child);
					} else {
						logger && logger.error('Found duplicate layout id "' + item.items[i].id + '" on initialization of layout "' + item.id + '".' );
					}
				}
			}
		});
		return copy;
	}

	model = trimDuplicateModels(model);
	// Need to pass in the model for contentModel for copy/paste and launch
	env.addOnLayoutSpec = model;

	let PreparedLayoutModelType;
	if(model.type && layoutTypes[model.type]) {
		PreparedLayoutModelType = composeMSTLayoutModel(env, layoutTypes[model.type], getItemsModelTypeFn)
			.named(model.type);
	} else {
		PreparedLayoutModelType = prepareMSTLayoutModelType(env, getItemsModelTypeFn);
	}

	const modelInstance = PreparedLayoutModelType.create(model, env);
	modelInstance.createLayoutModel = createMSTLayoutModel;
	return modelInstance;
}



// WEBPACK FOOTER //
// ./src/js/core/MSTLayoutModelFactory.js